import Template from '../../component/Template.js';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useAuth from '../../component/useAuth.js';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Api from '../../component/Api.js';
import { Link } from 'react-router-dom';
import React, { useRef } from "react";

import 'datatables.net';
import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css';


export default function Vendorlist() {





  const tableRef = useRef(null);


  {/*------------------------------------*/ }
  /* CUSTOM DATA TABLE BEGIN HERE */
  
  const [tableData, setTableData] = useState([]);

  const [sortBy, setSortBy] = useState({ column: null, direction: 'asc' }); //sort
  const [searchQuery, setSearchQuery] = useState('');
  const [filteredAndSortedData, setfilteredAndSortedData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [total_count, setTotal] = useState(null);

  const [reload, setReload] = useState(false);




  const [isDeleteUser, setDeleteUser] = useState(false);
  const [deleteUserID, setDeleteUserID] = useState(false);



  /* CUSTOM DATA TABLE END HERE */


  const { http } = Api();
  const navigate = useNavigate();

  const isAuth = useAuth();

  if (isAuth === false) {
    navigate("/imu/");
  }


  let cid = localStorage.getItem("collegeid");
  let collegename = localStorage.getItem("username");


  useEffect(() => {


    const getCollegeUsersList = async () => {
      try {
        const response = await http.post(`/College/listVendor`);

      
        //console.log("res", response.data.data);
        setTableData(response.data.data);

      }
      catch (error) {

        if (error.response.data.http_status === 401 && error.response.data.status_code == "ERR9") {
          toast.error("Invalid Token");
          setTimeout(() => {
            navigate("/imu/");
          }, 5000);

        }
        else if (error.response.data.http_status === 429 && error.response.data.status_code == "ERR33") {
          toast.error(error.response.data.message);
        }
        else {
          toast.error("Something went wrong");
        }
      }
    };


    getCollegeUsersList();


  }, [reload]);


  /* DATA TABLE  */

  const handleSearchInputChange = (event) => {

    setSearchQuery(event.target.value);
  };

  const handleSort = (column) => {

    const newSortBy = {
      column,
      direction: sortBy.column === column && sortBy.direction === 'asc' ? 'desc' : 'asc',
    };
    setSortBy(newSortBy);
  };


  useEffect(() => {
    const filteredAndSortedData = [...tableData].filter(tableDatas => {
      return (
        (tableDatas.name ?? '').toLowerCase().includes(searchQuery.toLowerCase()) ||
        (tableDatas.email ?? '').toLowerCase().includes(searchQuery.toLowerCase()) ||
        (tableDatas.phone_no ?? '').toLowerCase().includes(searchQuery.toLowerCase()) ||
        (tableDatas.college_course_type ?? '').toString().toLowerCase().includes(searchQuery.toLowerCase()) ||
        (tableDatas.user_type_name ?? '').toString().toLowerCase().includes(searchQuery.toLowerCase()) ||
        (tableDatas.status ?? '').toString().toLowerCase().includes(searchQuery.toLowerCase())

      );
    }).sort((a, b) => {
      if (sortBy.direction === 'asc') {
        return a[sortBy.column] > b[sortBy.column] ? 1 : -1;
      } else {
        return a[sortBy.column] < b[sortBy.column] ? 1 : -1;
      }
    });

    const itemsPerPage = 50;
    const startIndex = (currentPage - 1) * itemsPerPage;
    const paginatedData = filteredAndSortedData.slice(startIndex, startIndex + itemsPerPage);

    setfilteredAndSortedData(paginatedData);
    setTotalPages(Math.ceil(filteredAndSortedData.length / itemsPerPage));
    setTotal(filteredAndSortedData.length);

  }, [searchQuery, sortBy, tableData, currentPage]);

  const renderSortIcon = (columnName) => {
    if (sortBy.column === columnName) {
      return sortBy.direction === 'asc' ? <i className="fa fa-sort-up ml-1" aria-hidden="true"></i> : <i className="fa fa-sort-down ml-1" aria-hidden="true"></i>;
    }
    return <i className="fa fa-sort ml-1" aria-hidden="true"></i>; // Show disabled sort icon
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };



  const handleGeneratePDFNew = async () => {
    // setLoading(true);
    try {
      const response = await http.get('/College/vendorListpdfDownload', {
        responseType: 'blob', // Expect binary response
      });

      if (response && response.data) {
        // Create a URL for the downloaded file
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;

        // Set the file name and download the PDF
        link.setAttribute(
          'download',
          `VendorList.pdf`
        );
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        // setLoading(false);
        toast.success('PDF generated successfully');
      }
    } catch (error) {
      //console.log("error",error);
      // setLoading(false);
      if (error.response.data.http_status === 401 && error.response.data.status_code == "ERR9") {
        toast.error("Invalid Token");
        setTimeout(() => {
          navigate("/college/");
        }, 5000);

      }
      else if (error.response.data.http_status === 500 && error.response.data.status_code == "ERR47") {
        toast.error(error.response.data.message);
      }
      else {
        console.error('Error generating PDF:', error);
        toast.error('Error generating PDF');
      }
    }
  };


  const handleDeleteUser = (userid) => {
    setDeleteUserID(userid);
    setDeleteUser(true);
  }
  const handleDeleteCancel = () => {
    setDeleteUser(false);
  }


  const handleDeleteSuccess = async () => {
    http
      .post('/College/deleteVendor', {
       
        id: deleteUserID,
       
      })
      .then((response) => {

        if (response.data.status_code === "MSG3") {

          setDeleteUser(false);
          sessionStorage.setItem("message", "User deleted successfully");
          toast.success("User data deleted successfully");
          setReload(!reload);

        }
      })
      .catch((error) => {

        const status = error.response?.data?.http_status;
        const code = error.response?.data?.status_code;
        const message = error.response?.data?.message || "An error occurred";
        setDeleteUser(false);
        if (code === "ERR_COURSE" && status === 500) {
          toast.error("Deletion not allowed. The user has courses that are already approved.");
        } else if (code === "ERR_COURSE2" && status === 500) {
          toast.error("Action not allowed after scripts have been received by your team.");
        } else if (status === 500 || code === "ERR5") {
          toast.error("No user found");
        } else if (status === 403 && code === "ERR37") {
          toast.error("Invalid Token");
          setTimeout(() => navigate("/college/"), 5000);
        } else {
          toast.error(message);
        }
      });
  };




  return (
    <>
      <ToastContainer />
      <Template>
        <div className="container-fluid">
          <div className="row">
            <div className="table-responsive">
              <div className="card">
                <div className="col-md-12">
                  <div className="card-header">
                    <div className="py-3 d-flex justify-content-between align-items-center">
                      <h5>Vendors</h5>
                    </div>
                  </div>
                  <div className="card-body">


                    <div className="table-responsive">

                      <div className="row align-items-center pdg18">
                        {/* Left 6 columns */}
                        <div className="col-md-8">

                        </div>

                        {/* Right 6 columns */}
                        <div className="col-md-4 d-flex justify-content-end">
                          <div className="d-flex gap-2">
                            <Link
                              className="btn custom-btn btn-primary common-btn d-inline-flex align-items-center justify-content-center"
                              to="/imu/imuusercreate"
                              title="Add New User"
                            >
                              <i className="bi bi-plus-square ctm-btn-sz m-r-5"></i>New
                            </Link>



                            <button
                              className="btn btn-primary common-btn d-inline-flex align-items-center justify-content-center pdf-btn"
                              onClick={() => handleGeneratePDFNew()}
                              title="Download to PDF"
                            >
                              <i className="bi bi-arrow-down-square ctm-btn-sz"></i>
                            </button>

                          </div>
                        </div>
                      </div>

                      <div className='row'>

                        <div className='col-md-6 wdt' >
                          <p>
                            Showing {(currentPage - 1) * 50 + 1}{''}-
                            {Math.min((currentPage - 1) * 50 + 50, total_count)} of {total_count} entries
                          </p>
                        </div>
                        <div className='col-md-6 wdt' align='right'>
                          <input
                            type="text"
                            value={searchQuery}
                            onChange={handleSearchInputChange}
                            placeholder="Search..."
                            className='form-control'
                          /></div></div>
                      <div class="table-containerq" style={{ overflowX: 'unset' }}>

                        <table className="display dataTable table-striped table-bordered ex-v-table " ref={tableRef}>
                          <thead>
                            <tr className="bg-primary">

                              <th onClick={() => handleSort('id')} scope="col" data-label="APAAR Id" width="8%">Sl No &nbsp;
                                {renderSortIcon('id')} </th>

                              <th onClick={() => handleSort('vendor_name')} scope="col" data-label="User Type" width="" > Vendor Name &nbsp;
                                {renderSortIcon('vendor_name')} </th>

                              <th onClick={() => handleSort('user_type')} scope="col" data-label="User Type" width="" > Vendor Type &nbsp;
                                {renderSortIcon('user_type')} </th>

                              <th onClick={() => handleSort('vendor_email')} scope="col" data-label="User Type" width="" >Email &nbsp;
                                {renderSortIcon('vendor_email')} </th>

                              <th onClick={() => handleSort('vendor_phoneno')} scope="col" data-label="User Type" width="" >Phone No &nbsp;
                                {renderSortIcon('vendor_phoneno')} </th>

                              <th onClick={() => handleSort('vendor_address')} scope="col" data-label="User Type" width="" >Address &nbsp;
                                {renderSortIcon('vendor_address')} </th>

                              <th scope="col" data-label="Action" width="">Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {filteredAndSortedData.length > 0 ? (() => {


                              // Sort so items of same group (discipline/type/ACS) stay together
                              const sortedData = [...filteredAndSortedData].sort((a, b) => {
                                const keyA = `${a.discipline_name ?? ''}-${a.college_discipline_type ?? ''}-${a.user_type_name ?? ''}`;
                                const keyB = `${b.discipline_name ?? ''}-${b.college_discipline_type ?? ''}-${b.user_type_name ?? ''}`;
                                return keyA.localeCompare(keyB);
                              });

                             
                              let serialNumber = (currentPage - 1) * 50 + 1;

                              // Render rows with group headers
                              return sortedData.map((item, index) => {
                               

                                return (
                                  <React.Fragment key={`${item.id}-${index}`}>

                                    <tr className="grouped-row">
                                      <td>{serialNumber++}</td>
                    
                                      <td>{item.vendor_name}</td>
                                      <td >{item.user_type == 'V'? 'Vendor' : 'Teacher'}</td>
                                      <td>{item.vendor_email}</td>
                                      <td>{item.vendor_mobileno}</td>
                                      <td>{item.vendor_address}</td>
                                      <td>
                                        <div className="d-flex justify-content-center" >

                                          <i className="fa fa-trash icn-out-bod" aria-hidden="true"
                                            onClick={() => handleDeleteUser(item.id)}
                                            style={{ cursor: 'pointer', marginBottom: "10px" }}
                                            title="Delete"></i>
                                        </div>
                                      </td>
                                    </tr>
                                  </React.Fragment>
                                );
                              });
                            })() : (
                              <tr>
                                <td colSpan="7" className="text-center">No data found</td>
                              </tr>
                            )}
                          </tbody>


                        </table>
                      </div>

                      {totalPages > 1 && (
                        <nav aria-label="..." style={{ cursor: "pointer" }}>
                          <ul className="pagination justify-content-center">
                            <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                              <span className="page-link pgn-clr" onClick={handlePreviousPage}><i class="bi bi-arrow-left-circle-fill"></i></span>
                            </li>
                            <li className={`page-item`}>
                              <span className="page-link pgn-clr" onClick={() => handlePageChange(1)}>1</span>
                            </li>
                            {currentPage > 4 && <li className="page-item"><span className="page-link pgn-clr">...</span></li>}
                            {[...Array(totalPages - 1).keys()].slice(currentPage > 4 ? currentPage - 3 : 1, currentPage + 2).map((pageNumber) => (
                              <li key={pageNumber} className={`page-item ${pageNumber + 1 === currentPage ? 'act-clr' : ''}`}>
                                <span className="page-link pgn-clr" onClick={() => handlePageChange(pageNumber + 1)}>{pageNumber + 1}</span>
                              </li>
                            ))}
                            {currentPage < totalPages - 3 && <li className="page-item"><span className="page-link pgn-clr">...</span></li>}

                            <li className={`page-item`}>
                              <span className="page-link pgn-clr" onClick={() => handlePageChange(totalPages)}>{totalPages}</span>
                            </li>

                            <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                              <span className="page-link pgn-clr" onClick={handleNextPage}><i class="bi bi-arrow-right-circle-fill"></i></span>
                            </li>
                          </ul>
                        </nav>
                      )}


                      {/*  Delete User */}
                      <div className={`modal fade show ${isDeleteUser ? 'd-block' : ''}`} id="exampleModalCenter1" tabIndex="-1" role="dialog" aria-labelledby="exampleModalCenter1" aria-model="true">
                        <div className="modal-dialog modal-dialog-centered" role="document">
                          <div className="modal-content">
                            <div className="modal-body">
                              <div className="modal-toggle-wrapper">
                               
                                <h4 className="text-center pb-2">Are you sure you want to delete?</h4>
                                <p className="text-center">This action cannot be undone. Please confirm if you want to proceed with the deletion.</p>
                                <div className="d-flex justify-content-center mt-3">
                                  <button className="btn btn-danger mx-2" onClick={() => handleDeleteSuccess()}>Delete</button>
                                  <button className="btn " style={{ backgroundColor: 'white', borderColor: 'red', color: 'black' }} data-bs-dismiss="modal" onClick={() => handleDeleteCancel()}>Cancel</button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/*  Delete User End */}


                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Template>
    </>
  );
}
